module.exports = __webpack_public_path__ + "media/HUD_1.4a66e626.mp4";